<template lang="pug">
.newCard
  vm-row.heading(vm-w="12")
    vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
      div
        h2 {{ $t('invoices.add') }}:
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: addSupply, push: true, focus: true, disabled: $v.invoice.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group.separator
        vm-date-picker.full-width(type="date" :label="$t('invoices.date')" :placeholder="$t('strings.select_date')" :danger="$v.invoice.date.$invalid && $v.invoice.date.$model" :danger-text="$t('validation.required', { attribute: $t('invoices.date') })" v-model="invoice.date" )
    vm-col(vm-align="center" vm-lg=4 vm-sm=4)
      b-form-group.separator
        vm-input(type="number" :placeholder='$t("invoices.discount_placeholder")' v-model="invoice.discount" :label='$t("invoices.discount")')
    vm-col(vm-align="center" vm-lg=4 vm-sm=4)
      b-form-group.separator
        vm-select(autocomplete :placeholder='$t("invoices.cfdi_placeholder")' :danger="$v.invoice.cfdi.$invalid && $v.invoice.cfdi.$model" :danger-text="$t('validation.required', { attribute: $t('invoices.tax_receipt_display') })" v-model="invoice.cfdi" :label='$t("invoices.tax_receipt_display")')
          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in catalog.taxReceipts")
  vm-row.margin-top(vm-w="12")
    vm-col(vm-sm=12)
      vm-table.overflow(:data="products")
        template(slot="thead")
          vm-th(:key="index" v-for="(column, index) in columns") {{ $t('customer_purchase_order_details.' + column) }}
        template(slot-scope="{data}")
          vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
            vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
              slot(v-if="column == 'unit_price'")  {{data[indextr][column] | currency }}
              slot(v-if="column == 'invoiced_amount'")  {{ data[indextr][column] }}
              vm-input(type="number" @input="onCheckValue(data[indextr])" v-if="column == 'amount_to_invoice'" v-model="data[indextr].amount_to_invoice")
              vm-input(disabled type="currency" v-if="column == 'total_import'" v-model="data[indextr].amount_to_invoice * data[indextr].unit_price")
              slot(v-if="column != 'invoiced_amount' && column != 'amount_to_invoice' && column != 'supply_order_quantity' && column != 'remaining' && column != 'supply' && column != 'created_at' && column != 'total_import' && column != 'amount' && column != 'unit_price'") {{data[indextr][column]}}
    transition(name="enter")
      .total-products(v-if="total>0") Total de productos: {{ products.length }}
  vm-row(vm-w="12")
    vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=12 vm-sm=12)
      div
        h2 {{ $t('customer_purchase_order_details.subtotal') }} {{ sub_total | currency}}
    vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=12 vm-sm=12)
      div
        h2 {{ $t('customer_purchase_order_details.tax') }} %{{ products[0].purchase_order.tax_type }}
    vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=12 vm-sm=12)
      div
        h2 {{ $t('customer_purchase_order_details.total_with_tax') }} {{ total_amount | currency }}
  vm-row(vm-sm="12")
    vm-col(vm-sm=12)
      vm-button.float-right(style="margin-top: 15px;" @click="addSupply" :disabled="$v.invoice.$invalid") {{ $t('strings.save') }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const { mapGetters, mapActions } = createNamespacedHelpers('Manufacturings')

export default {
  name: 'CreateInvoice',
  mixins: [ViewMixinMaster1],
  data: () => ({
    invoice: {},
    columns: [
      'name',
      'quantity',
      'invoiced_amount',
      'amount_to_invoice',
      'unit_price',
      'total_import'
    ],
    searchParam: ''
  }),
  validations () {
    return {
      invoice: {
        date: {
          required
        },
        cfdi: {
          required
        },
        discount: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['catalog', 'filterParams', 'sub_total', 'total_amount', 'products'])
  },
  async created () {
    this.initialSum()
  },
  methods: {
    ...mapActions([
      'setSubTotal',
      'setTotalAmount',
      'createInvoice'
    ]),
    async addSupply () {
      this.form = {
        products: this.products,
        total: this.total_amount - this.invoice.discount,
        subtotal: this.sub_total,
        discount: parseFloat(this.invoice.discount),
        date: moment(this.invoice.date).format('YYYY-MM-DD'),
        purchase_order_id: this.products[0].purchase_order.id,
        tax_type: this.products[0].purchase_order.tax_type,
        tax_receipt_id: this.invoice.cfdi
      }
      this.createInvoice(this.form).then(() => {
        this.products = []
        this.$router.back()
      })
    },
    onSearch () {
      this.searchParam ? this.products = Array(...this.products.filter(product => product.name.toLowerCase().includes(this.searchParam.toLowerCase()))) : this.products = { ...this.products }
    },
    initialSum () {
      var index
      for (index = 0; index < this.products.length; index++) {
        this.products[index].total_import = this.products[index].amount_to_invoice * this.products[index].unit_price
      }
      this.setSubTotal(this.products)
      this.setTotalAmount(this.products)
    },
    onCheckValue (data) {
      setTimeout(() => {
        if (data.amount_to_invoice <= 0 || data.amount_to_invoice > data.quantity) {
          data.amount_to_invoice = 1
          return data.amount_to_invoice
        }
        return data.amount_to_invoice
      }, 500)
      const product = this.products.findIndex(u => u.id === data.id)
      this.products[product].total_import = data.amount_to_invoice * data.unit_price
      this.setSubTotal(this.products)
      this.setTotalAmount(this.products)
    }
  }
}
</script>
<style lang="scss">
.margin-top {
  margin-top: -30px;
}
.overflow {
  max-height: 45vh;
  overflow-y: auto;
}
</style>
